import { AxiosResponse } from 'axios'
import { HttpService } from '@/services/common/HttpService'
import { TableViewParameters, TableViewResult } from '@/models/TableView'
import {
  Customer,
  CustomerResponseDTO,
  CustomerSearchParams,
  CustomerSearchResponse,
  QuoteFormCustomerDetail,
} from '@/models/dto/Customer'
import { ApiResult } from '@/models/dto'

const httpService: HttpService = new HttpService()

export default {
  getCustomers(params: TableViewParameters): Promise<AxiosResponse<TableViewResult<Customer>>> {
    const { pageSize = 10, page = 1, sorts = null, filters = null } = params

    let query = `page=${page}&pageSize=${pageSize}`
    if (sorts) {
      query += `&${sorts}`
    }
    if (filters) {
      query += `&${filters}`
    }
    query = encodeURI(query)

    const url = `/tables/customers?${query}&v2=true`
    return httpService.get(url)
  },
  searchCustomers(params: CustomerSearchParams): Promise<AxiosResponse<CustomerSearchResponse>> {
    return httpService.get('/customers/search', { params })
  },
  getQuoteFormDetail(customerId: number): Promise<AxiosResponse<QuoteFormCustomerDetail>> {
    const url = `/customers/${customerId}/quote-form-detail`
    return httpService.get(url)
  },
  getCustomer(customerId: number): Promise<AxiosResponse<CustomerResponseDTO>> {
    const url = `/customers/${customerId}`
    return httpService.get(url)
  },
  getCustomerByExternalId(externalCustomerId: string): Promise<AxiosResponse<CustomerResponseDTO>> {
    const url = `/customers/externalId/${externalCustomerId}`
    return httpService.get(url)
  },
  updateCustomer(params: { id: number; payload: Customer }): Promise<AxiosResponse<ApiResult>> {
    const url = `/customers/${params.id}`
    return httpService.patch(url, params.payload)
  },
  updateUserCalls(params): Promise<AxiosResponse<ApiResult>> {
    const url = `/customers/updateUserCalls/${params.previousUserId}/${params.newUserId}/${params.callId}`
    return httpService.post(url, params.payload)
  },
  addCustomer(params): Promise<AxiosResponse<ApiResult & { customer: Customer }>> {
    const url = `/customers`
    return httpService.post(url, params.payload)
  },
  deleteCustomer(customerId: number): Promise<AxiosResponse<ApiResult>> {
    const url = `/customers/${customerId}`
    return httpService.delete(url)
  },
  exportCustomers(params: TableViewParameters): Promise<AxiosResponse<any>> {
    const { pageSize = 10, page = 1, sorts = null, filters = null } = params

    let query = `page=${page}&pageSize=${pageSize}`
    if (sorts) {
      query += `&${sorts}`
    }
    if (filters) {
      query += `&${filters}`
    }
    query = encodeURI(query)

    const url = `/customers/export?${query}`
    return httpService.get(url)
  },
  getCustomerAccountDefaultsByCustomer(customerId: number): Promise<AxiosResponse<ApiResult>> {
    const url = `/customers/${customerId}/effectiveDefaultValueSet`
    return httpService.get(url)
  },
  sendCustomerForgotPasswordEmail(payload: { email: string }): Promise<AxiosResponse<ApiResult>> {
    const url = `/customers/customerForgotPassword`
    return httpService.post(url, payload)
  },
  sendCustomerInviteEmail(customerId: number): Promise<AxiosResponse<ApiResult>> {
    const url = `/customers/${customerId}/sendInviteEmail`
    return httpService.post(url, {})
  },
  getCustomerServiceTier(customerId: number): Promise<AxiosResponse<ApiResult>> {
    const url = `/customers/${customerId}/domain-service-tier`
    return httpService.get(url)
  },
}
